import { render } from "./MultipleAnswer.vue?vue&type=template&id=113cb188&ts=true"
import script from "./MultipleAnswer.vue?vue&type=script&lang=ts"
export * from "./MultipleAnswer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__